export interface DataEntity_Detail_08_Interface {
    id: number,
    main_id: number,
  
    reference_Value: string,
    indication: string,
    correction: string,
    uncertainty: string,
    converage: string,

    
    reference_Value_2: string,
    indication_2: string,
    correction_2: string,
    uncertainty_2: string,
    converage_2: string,
  }
  
  export function Empty_DataEntity_Detail_08_Interface(): DataEntity_Detail_08_Interface {
    return {
      id: 0,
      main_id: 0,
  
      reference_Value: '',
      indication:'' ,
      correction: '',
      uncertainty: '',
      converage: '',
      
      reference_Value_2: '',
      indication_2: '',
      correction_2:'' ,
      uncertainty_2:'' ,
      converage_2:'' ,
    }
  }
